module.exports = __webpack_public_path__ + "img/yorkshireterrier80.8868942e.jpg";